<template>
    <page :tabs="tabs" :busy="busy">
        <grid ref="grid" :rowData="items" :columnDefs="columnDefs">
            <responsive-button
                :icon="['fas', 'plus']"
                @click="openCreateModal"
                variant="primary"
            >
                Add Module
            </responsive-button>
        </grid>
        <create-edit-module-modal
            :modalId="'create-module-modal'"
            @submit="createModule"
            :modalTitle="'Create Module'"
        ></create-edit-module-modal>
    </page>
</template>

<script>
import API from '../../api';
import Grid from '../generic/grid/grid.vue';
import page from '../generic/page/page.vue';
import ResponsiveButton from '../generic/responsive-button/responsive-button.vue';
import ActionsCellRenderer from './actions-cell-renderer.vue';
import { removeScrollMixin } from '../../mixins/remove-scroll-mixin';
import {
    SUBSCRIPTION_MODULES_ENDPOINT,
    UPDATE_DELETE_MODULE_ENDPOINT,
} from '../../endpoints';
import CreateEditModuleModal from './create-edit-module-modal.vue';

export default {
    name: 'SubscriptionModules',
    components: {
        page,
        Grid,
        ResponsiveButton,
        CreateEditModuleModal,
        actionsCellRenderer: ActionsCellRenderer,
    },
    data() {
        return {
            items: [],
            tabs: [{ title: 'Modules', active: true }],
            busy: null,
        };
    },
    mixins: [removeScrollMixin],

    methods: {
        async openCreateModal() {
            this.$bvModal.show('create-module-modal');
        },
        async createModule(value) {
            try {
                this.busy = true;
                await API.post(SUBSCRIPTION_MODULES_ENDPOINT(), value);
                this.$bvModal.hide('create-module-modal');
                await this.fetchModules();
            } catch (e) {
                this.errorToast({ text: 'Could not create module' });
            } finally {
                this.busy = false;
            }
        },
        async fetchModules() {
            try {
                this.busy = true;
                const response = await API.get(SUBSCRIPTION_MODULES_ENDPOINT());
                this.items = response.data;
            } catch (e) {
                this.errorToast({ text: 'Could not load data' });
            } finally {
                this.busy = false;
            }
        },
    },
    mounted() {
        this.fetchModules();
    },
    computed: {
        columnDefs() {
            return [
                {
                    field: 'name',
                    headerName: 'Name',
                },
                {
                    field: 'description',
                    headerName: 'Description',
                },
                {
                    field: 'package',
                    headerName: 'Package',
                    valueGetter: ({ data }) =>
                        data.package ? data.package.name : 'All Packages',
                },
                {
                    field: 'subscribers_count',
                    headerName: 'Subscribers',
                    maxWidth: 150,
                    cellRenderer: ({ data }) => {
                        return data.subscribers_count
                            ? `<a href=${
                                  window.location.origin +
                                  `/app/subscriber/admin/subscriptions/?addon=${data.id}`
                              }>${data.subscribers_count}</a>`
                            : data.subscribers_count;
                    },
                },
                {
                    field: 'amount',
                    headerName: 'Amount($) ',
                    maxWidth: 120,
                },
                {
                    field: 'status',
                    headerName: 'Status',
                    maxWidth: 150,
                },
                {
                    field: '',
                    maxWidth: 150,
                    sortable: false,
                    cellStyle: { display: 'flex', justifyContent: 'center' },
                    cellRenderer: 'actionsCellRenderer',
                    cellRendererParams: {
                        deleteModule: async (id, modalId) => {
                            try {
                                this.busy = true;
                                await API.delete(
                                    UPDATE_DELETE_MODULE_ENDPOINT(id)
                                );
                                this.$bvModal.hide(modalId);
                                await this.fetchModules();
                            } catch (e) {
                                this.errorToast({
                                    text: 'Could not delete module',
                                });
                            } finally {
                                this.busy = false;
                            }
                        },
                        updateModule: async (id, value, modalId) => {
                            try {
                                this.busy = true;
                                await API.patch(
                                    UPDATE_DELETE_MODULE_ENDPOINT(id),
                                    value
                                );
                                this.$bvModal.hide(modalId);
                                await this.fetchModules();
                            } catch (e) {
                                this.errorToast({
                                    text: 'Could not update module',
                                });
                            } finally {
                                this.busy = false;
                            }
                        },
                    },
                },
            ];
        },
    },
};
</script>